/* import __COLOCATED_TEMPLATE__ from './tags.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./tags.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());